import { Component, useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { HashRouter, Routes, Route } from "react-router-dom";
import Landing from "./components/Landing";
import AppView from "./components/AppView";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { err: false };
  }
  static getDerivedStateFromError() {
    return { err: true };
  }
  componentDidCatch(error) {
    console.error(error);
  }
  render() {
    if (this.state.err) {
      return (
        <div className="grid min-h-screen place-items-center bg-[#04070F] px-6 text-center">
          <div>
            <p className="font-display text-2xl font-bold text-white">
              Something went wrong
            </p>
            <p className="mt-2 text-sm text-slate-400">
              Please refresh the page to continue.
            </p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  useEffect(() => {
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    ) {
      return;
    }
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <div className="grain relative min-h-screen overflow-x-clip bg-[#04070F] font-sans text-slate-200">
        <HashRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/app" element={<AppView />} />
            <Route path="*" element={<Landing />} />
          </Routes>
        </HashRouter>
      </div>
    </ErrorBoundary>
  );
}

export default App;
